import { IBanners } from 'shared/types/guide';
import * as styles from './styles.css';
import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { useSelector } from 'react-redux';
import { selectDealType } from 'shared/selectors/dealType';

type TColoredBannerProps = IBanners;

export const ColoredBanner: React.FC<TColoredBannerProps> = ({ title, linkBtn, imageClass }) => {
  const device = useDeviceType();

  const dealType = useSelector(selectDealType);

  return (
    <div className={clsx(styles['container'], styles[device], styles[dealType])}>
      <div className={styles['textblock']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['btn']}>
          <LinkButton fullWidth size={device === 'desktop' ? 'L' : 'M'} href={linkBtn.url} target="_blank">
            {linkBtn.text}
          </LinkButton>
        </div>
      </div>
      <div className={clsx(styles['image'], styles[imageClass])} />
    </div>
  );
};
